import React from 'react';
import { LanguageContext } from '../contexts/LanguageContext';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <LanguageContext.Consumer>
          {({ t }) => (
        <div style={{
          padding: '40px',
          background: '#fff3cd',
          border: '2px solid #ffc107',
          borderRadius: '12px',
          textAlign: 'center',
          margin: '20px 0'
        }}>
          <h3 style={{ 
            color: '#856404', 
            marginBottom: '12px',
            fontSize: '18px' 
          }}>
            {t('Chart Display Error')}
          </h3>
          <p style={{ 
            color: '#856404', 
            marginBottom: '20px',
            fontSize: '14px' 
          }}>
            {t('Unable to render this chart. This might be a temporary issue.')}
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px',
              background: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.background = '#0056b3'}
            onMouseOut={(e) => e.target.style.background = '#007bff'}
          >
            {t('🔄 Refresh Page')}
          </button>
        </div>
          )}
        </LanguageContext.Consumer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;